// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickSubmitBody = {
  poolId: string;
  requestId?: string | null;
  contestId: string;
  roundId: string;
  entryId: string;
  picks: {
    eventId: string;
    teamId: string;
    acceptsPendingSpread?: boolean | null;
  }[];
};

export type typePickSubmitOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accepted: boolean;
    entry: { status: "in" | "eliminated" | "revived"; livesRemaining: number };
  };
};

export type typePickSubmitOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickSubmitOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickSubmitOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickSubmitBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    requestId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: { type: "string", maxLength: 3000, minLength: 1 },
    picks: {
      type: "array",
      items: {
        type: "object",
        properties: {
          eventId: { type: "string", maxLength: 3000, minLength: 1 },
          teamId: { type: "string", maxLength: 3000, minLength: 1 },
          acceptsPendingSpread: {
            oneOf: [{ type: "boolean" }, { enum: [null] }],
          },
        },
        required: ["eventId", "teamId"],
      },
    },
  },
  required: ["poolId", "contestId", "roundId", "entryId", "picks"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickSubmit(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickSubmitBody);
  }

  return async function postPickSubmit(
    payload: typePickSubmitBody,
  ): Promise<typePickSubmitOutput200 | typePickSubmitOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickSubmit" failed before calling the network. #5d685a8dcd45`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5d685a8dcd45" },
        },
        data: null,
      } as typePickSubmitOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pick/submit`,
      httpMethod: "POST",
      options,
    })) as typePickSubmitOutput200 | typePickSubmitOutput400;
  };
}
